//src\components\portal\portal_services\portal_session.js

class PortalSession {
    constructor() {
      this.customerId = "";
      this.customerToken = "";
      //this.baseURL = "http://127.0.0.1:4000";
      this.baseURL = "https://searcheble-cloudrun-test-rebinder-v1-743663438976.australia-southeast1.run.app";
      this.lastupdate = "";
      this.loadFromStorage();
    }

    loadFromStorage() {
      try {
        const stored = sessionStorage.getItem('portalSession');
        if (stored) {
          const sessionData = JSON.parse(stored);
          this.customerId = sessionData.customerId || "";
          this.customerToken = sessionData.customerToken || "";
          this.lastupdate = sessionData.lastupdate || "";
        }
      } catch (error) {
        console.error('Error loading session from storage:', error);
        this.customerId = "";
        this.customerToken = "";
        this.lastupdate = "";
      }
    }

    saveToStorage() {
      const sessionData = {
        customerId: this.customerId,
        customerToken: this.customerToken,
        lastupdate: this.lastupdate
      };
      sessionStorage.setItem('portalSession', JSON.stringify(sessionData));
    }

    setSession(customerId, customerToken) {
      this.customerId = customerId || "";
      this.customerToken = customerToken || "";
      this.saveToStorage();
    }
  
    // Setters
    setCustomerId(customerId) {
      this.customerId = customerId || "";
      this.saveToStorage();
    }
  
    setCustomerToken(customerToken) {
      this.customerToken = customerToken || "";
      this.saveToStorage();
    }

    setLastUpdate(lastupdate) {
      this.lastupdate = lastupdate || "";
      this.saveToStorage();
    }
  
    // Getters
    getLastUpdate() {
      return this.lastupdate;
    }

    getBaseURL() {
      return this.baseURL;
    }

    getCustomerId() {
      return this.customerId;
    }
  
    getCustomerToken() {
      return this.customerToken;
    }
  
    // Get both values as an object
    getSession() {
      return {
        customerId: this.customerId,
        customerToken: this.customerToken
      };
    }
  
    // Check if user is logged in (both values exist)
    isLoggedIn() {
      return this.customerId !== "" && this.customerToken !== "";
    }
  
    // Clear session (for logout)
    clearSession() {
      this.customerId = "";
      this.customerToken = "";
      this.lastupdate = "";
      sessionStorage.removeItem('portalSession');
    }
  }
  
  // Create a singleton instance
  const portalSession = new PortalSession();
  
  export default portalSession;